import { HStack, Stack, Text } from "@chakra-ui/react";
import { KeyboardHint } from "../../../../shared/views/KeyboardHint/KeyboardHint";
import { observer } from "mobx-react";
import { useStores } from "../../../../shared/stores/RootStore";
import { LifeCycleStage } from "../../../../osaway/models/LifeCycleStage";

const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

const ctrlKey = isMac ? "⌘" : "Ctrl";
const leftKey = <>&#8592;</>;
const rightKey = <>&#8594;</>;
const shiftKey = "⇧";

const ShortcutListBase = () => {
  const { osaNodeStore, osaWayStore, hlaStore } = useStores();

  const nodeSelected = !!osaNodeStore.selectedId;
  const selectedOsaWay = osaWayStore.getSelected();

  const osaNodeMultiSelectionEnabled =
    !!selectedOsaWay &&
    (selectedOsaWay.lifeCycleStage === LifeCycleStage.DataCollection ||
      selectedOsaWay.lifeCycleStage === LifeCycleStage.Coding);

  const hlaWayMultiSelectionEnabled = !!hlaStore.selectedId;

  return (
    <Stack fontSize="sm">
      {(osaNodeMultiSelectionEnabled || hlaWayMultiSelectionEnabled) && (
        <HStack>
          <KeyboardHint
            keys={[shiftKey, <Text fontSize={"xs"}>click</Text>]}
            label="or"
          />
          <KeyboardHint
            keys={[shiftKey, <Text fontSize={"xs"}>drag</Text>]}
            label={`to toggle multi selection`}
          />
        </HStack>
      )}
      {nodeSelected && (
        <>
          <KeyboardHint keys={[leftKey]} label={`to go to the previous node`} />
          <KeyboardHint keys={[rightKey]} label={`to go to the next node`} />
          <KeyboardHint
            keys={[ctrlKey, leftKey]}
            label={`to go to the first node`}
          />
          <KeyboardHint
            keys={[ctrlKey, rightKey]}
            label={`to go to the last node`}
          />
        </>
      )}
    </Stack>
  );
};

export const ShortcutList = observer(ShortcutListBase);
